import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { required, type } from '@/commons/utils/Rules';
import { getSelds } from "@/routes/api/resources";
import moment from "moment";
import baseFormFlujo from "@/components/Flujo/Templates/baseFormFlujo";
import { getConfigSimulador } from "@/routes/api/views/flujo";
import { getFromLocal } from "@/commons/utils/storage";
export default {
  name: 'PzBaseSimulador',
  components: {},
  mixins: [baseFormFlujo],
  data: function data() {
    return {
      reference: 'form',
      hoy: '',
      elOfertaView: 'solicitud',
      monto_label: '',
      fechapago_label: '',
      form: {
        monto: this.producto.min_monto,
        plazo: this.producto.min_cuota,
        cuota_sugerida: '',
        monto_oferta: '',
        trabajadores: 1,
        fecha_vencimiento: '',
        tasa: null,
        emision: ''
      },
      max_cuota: 1,
      max_monto: 1,
      min_cuota: 1,
      min_monto: 1,
      workers: [],
      validation: {
        monto: [required(''), type({
          field: '',
          type: 'number'
        })],
        plazo: [required(''), type({
          field: '',
          type: 'number'
        })]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      pickerOptionsEmision: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    emitChange: function emitChange() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('simular', _this.form);
      });
    },
    handleInput: function handleInput() {
      this.$emit('input', this.form);
    },
    setLabels: function setLabels() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.producto.needsDocuments) {
                  _this2.monto_label = _this2.$t('forms_flujo.PzSimulator.how_many_discount');
                  _this2.fechapago_label = _this2.$t('forms_flujo.PzSimulator.limit_date');

                  _this2.getOfertaView('descuentos');
                } else {
                  _this2.monto_label = _this2.$t('forms_flujo.PzSimulator.how_many_cash');
                  _this2.fechapago_label = _this2.$t('forms_flujo.PzSimulator.first_limit_date');

                  _this2.getOfertaView('solicitud');
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getOfertaView: function getOfertaView(tipe) {
      this.elOfertaView = tipe + '-' + this.extraData.ofertaView;
    },
    stablishDate: function stablishDate() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var date;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.producto.needsFirstDate) {
                  date = moment().add(1, 'W').format("DD-MM-YYYY");
                  _this3.hoy = date;
                  _this3.form.fecha_vencimiento = date;
                  _this3.validation.fecha_vencimiento = [required('')];
                  _this3.form.emision = date;
                  _this3.validation.emision = [required('')];

                  _this3.$emit('pick', new Date(date));
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    stablishSelds: function stablishSelds() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this4.producto.needsSelds) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", getSelds().then(function (res) {
                  _this4.$store.dispatch('loader/up', {
                    trigger: _this4.$options.name
                  });

                  _this4.workers = res.data;
                  _this4.validation.trabajadores = [required('')];
                }).catch(function () {
                  _this4.workers = [];
                }).finally(function () {
                  _this4.$store.dispatch('loader/down', {
                    trigger: _this4.$options.name
                  });
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getConfSimulador: function getConfSimulador() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var data_client, params;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.$store.dispatch('loader/up', {
                  trigger: _this5.$options.name
                });

                data_client = getFromLocal('data_client');
                params = {
                  code: _this5.producto.code_string,
                  documento: data_client ? data_client['identity'] : null
                };
                _context4.next = 5;
                return getConfigSimulador(params).then(function (res) {
                  var data = res.data;
                  _this5.min_cuota = data.min_cuota;
                  _this5.max_cuota = data.max_cuota;
                  _this5.min_monto = data.min_monto;
                  _this5.max_monto = data.max_monto;
                  _this5.form.monto = data.min_monto;
                  _this5.form.plazo = data.min_cuota;

                  if (_this5.max_monto <= 0 || _this5.max_monto < _this5.min_monto) {
                    _this5.$store.dispatch('loader/down', {
                      trigger: _this5.$options.name
                    });

                    _this5.$router.push({
                      name: 'Rejected'
                    });
                  }
                }).catch(function (error) {
                  _this5.$store.dispatch('app/catchErrors', {
                    _this: _this5,
                    error: error
                  });
                }).finally(function () {
                  _this5.$store.dispatch('loader/down', {
                    trigger: _this5.$options.name
                  });
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    fetchData: function fetchData() {
      var _this6 = this;

      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      var workers = this.stablishSelds();
      var date = this.stablishDate();
      var labels = this.setLabels();
      var getConfSimulador = this.getConfSimulador();
      return Promise.all([getConfSimulador, workers, labels, date]).then(function () {
        _this6.emitChange();
      }).finally(function () {
        _this6.$store.dispatch('loader/down', {
          trigger: _this6.$options.name
        });
      });
    }
  }
};